module.exports = __webpack_public_path__ + "static/media/dual-color-warp.1281e845.png";